import { Component } from "@angular/core";
import { BaseGridComponent } from "../base-grid/base-grid.component";

@Component({
  selector: "app-driver-status-grid",
  templateUrl: "../../components/base-grid/base-grid.component.html",
  styleUrls: ["./driver-status-grid.component.scss"],
})
export class DriverStatusGridComponent extends BaseGridComponent {}
